<template>
  <v-dialog v-model="user" persistent fullscreen hide-overlay transition="dialog-bottom-transition">
    <v-card>
      <v-btn class="close default v-btn--simple" @click="closeUser">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-card-text v-if="user">
        <material-card class="card-tabs" color="#444">
          <v-flex slot="header">
            <v-tabs v-model="tabs" hide-slider="false" color="transparent" slider-color="white">
              <v-tab class="mr-3">
                <v-icon class="mr-2">mdi-alert-circle-outline</v-icon>Информация
              </v-tab>
              <v-tab class="mr-3">
                <v-icon class="mr-2">mdi-cart-outline</v-icon>Покупки
              </v-tab>
              <v-tab>
                <v-icon class="mr-2">mdi-qrcode-scan</v-icon>История начислений
              </v-tab>
            </v-tabs>
          </v-flex>
          <v-tabs-items>
            <v-tab-item>
              <div class="tab-user">
                <Info  v-if="tabs===0 && user" :user="user" />
                <OrdersInfo v-else-if="tabs===1 && user" :user="user" />
                <ActivationsInfo v-else-if="tabs===2 && user" :user="user" />
              </div>
            </v-tab-item>
          </v-tabs-items>
        </material-card>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import Loader from "../helper/Loader";
import Info from "./Dealers/Info";
import OrdersInfo from "./Dealers/OrdersInfo";
import ActivationsInfo from "./Dealers/ActivationsInfo";

export default {
  components: { ActivationsInfo, OrdersInfo, Info, Loader },
  data() {
    return {
      tabs: -1
    };
  },
  methods: {
    ...mapMutations(["SET_USER"]),
    closeUser() {
      this.SET_USER(null);
    },
  },
  computed: {
    ...mapState(["user"])
  },
  mounted() {

    this.tabs = 0;
  }
};
</script>


<style lang="scss">
.tab-user {
  padding-top: 20px;
  min-height: 70vh;
  max-width: 95%;
  margin-left: auto;
  margin-right: auto;
}

.close {
  position: absolute !important;
  top: -8px;
  right: -13px;
  i {
    font-size: 80px;
  }
}
</style>
